import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 08:54
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual component to show a offer dialog if offer has offer pending or offer ready state
 */
export class OfferDescriptionVisualOfferDialog implements IOfferDescriptionVisualParameter {
    private _dialogName: string;
    private _autoShow: boolean = false;

    constructor(dialogName: string, autoShow: boolean) {
        this._dialogName = dialogName;
        this._autoShow = autoShow;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_OFFER_DIALOG;
    }

    public parseFromObjectParam(params: any): void {
        if (params.DN) {
            this._dialogName = params.DN;
        }
        else {
            this._dialogName = params.ODN;
        }	// todo: remove this in next sprint

        if (params.AS != null) {
            this._autoShow = params.AS;
        }
        else {
            this._autoShow = true;
        }
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // if the offer is in offer ready state check if the offer has not set the autoAccept flag set or have acception cost to show the dialog.
        // Otherwise skip this dialog, offer will jump to succeed state in next server step.

        if (this.ExecutionHook()) {
            return true;
        }

        // Otherwise show offer dialog
        // OVERRIDE TO EXECUTE DIALOGHANDLER
        //BasicDialogHandler.getInstance().registerDialogs(_dialogName, new BasicPrivateOfferDialogProperties(offerVO));
        return true;
    }

    private ExecutionHook(): boolean {
        // can be overriden
        return false;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return state === PrivateOfferStateEnum.OFFER_PENDING || state === PrivateOfferStateEnum.OFFER_READY;
    }

    public get dialogName(): string {
        return this._dialogName;
    }

    public get autoShow(): boolean {
        return this._autoShow;
    }

    public dispose(): void {
        this._dialogName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_OFFER_DIALOG";
    }
}

